import React from 'react';

const defaultContextValue = {
  channel: 'desktop',
  configService: {},
  cookie: {},
  customer: {},
  dataType: '',
  deliveryZip: '',
  experiement: {},
  hosts: {},
  isDebugMode: false,
  isLocal: false,
  isSPAEnabled: false,
  mounted: false,
  nearByStores: [],
  path: '/',
  referer: '',
  segment: '',
  store: {}
};

const DataProviderContext = React.createContext(defaultContextValue);

export default DataProviderContext;
